export const LABEL = "Show the student's rankings after submission";
export const MESSAGE = 'The students will be able to view their rank among the respondees after answering the quiz';
